import { Code } from "@/services/code-service";

  const highPriorityColour = "bg-red-100 text-red-800"
  const mediumPriorityColour = "bg-yellow-100 text-yellow-800"
  const lowPriorityColour = "bg-green-100 text-green-800"

  export const actionPriorityCodeDefault = "689a26d1f9f0ec14ad99d8de" // low
  export const actionStatusCodeDefault = "689a260cf9f0ec14ad99d8d7" // new

  // Priority color mapping with Record utility for type safety
  export const priorityColors: Record<Code["id"], string> = {
    "689a26d1f9f0ec14ad99d8dc": highPriorityColour, // high
    "689a26d1f9f0ec14ad99d8dd": mediumPriorityColour, // medium
    [actionPriorityCodeDefault]: lowPriorityColour, // low
  };

  export const featurePriorityColour: Record<Code["id"], string> = {
    "6877d6bae923ad6c31bf7288": "bg-green-100 text-red-800", // high
    "6877d6f9e923ad6c31bf7289": "bg-yellow-100 text-yellow-800", // medium
    "6877d714e923ad6c31bf728a": "bg-red-100 text-red-800", // low
    "6877d722e923ad6c31bf728b": "bg-gray-100 text-blue-800", // tbc
    "6877d731e923ad6c31bf728c": "bg-gray-100 text-gray-800", // na
  };

  export const priorityProjectColors: Record<Code["id"], string> = {
    "68b5768a3286810fecb95c29": highPriorityColour, // critical
    "68b4704749b0f309d2a4af28": "bg-orange-100 text-orange-800", // high
    "68b4704749b0f309d2a4af29": mediumPriorityColour, // medium
    "68b4704749b0f309d2a4af2a": lowPriorityColour, // low
  };

    export const stageProjectColors: Record<Code["id"], string> = {
    "68b4770949b0f309d2a4af39": "bg-lime-200 text-lime-800", // Planning
    "68b574493286810fecb95c24": "bg-purple-200 text-purple-800", // Proposed
    "68b4770949b0f309d2a4af38": "bg-teal-200 text-teal-800", // Approved
    "68b4770949b0f309d2a4af3a": "bg-green-100 text-green-800", // In-Progress
    "68b574493286810fecb95c25": "bg-rose-100 text-rose-800", // Completed
    "68b574493286810fecb95c26": "bg-red-100 text-red-800", // On-Hold
    "68b574493286810fecb95c27": "bg-gray-100 text-gray-800", // Cancelled
  };

  // Status color mapping with Record utility for type safety
  export const actionStatusColors: Record<Code["id"], string> = {
    "689a260cf9f0ec14ad99d8da": "bg-blue-100 text-blue-800", // In Progress
    "689a260cf9f0ec14ad99d8db": "bg-green-100 text-green-800", // completed
    "689a260cf9f0ec14ad99d8d9": "bg-red-100 text-red-800", // Approved
    "689a260cf9f0ec14ad99d8d8": "bg-gray-100 text-gray-800", // Proposed
    [actionStatusCodeDefault]: "bg-orange-100 text-orange-800", // New
  };